import type { SearchResultItem } from '~/modules/search';
import type { ProjectPinDetailFragment } from 'generated/graphql';
import type { BasicThumbnail } from '~/utils/get-tile-thumbnail-for-professional';
import { isBasicThumbnail } from '~/utils/get-tile-thumbnail-for-professional';

type projectWithThumbnail =
    | BasicThumbnail
    | SearchResultItem
    | ProjectPinDetailFragment;

const isSearchResultItem = (p: projectWithThumbnail): p is SearchResultItem => {
    return (p as SearchResultItem).PType !== undefined;
};

// we have many place need to maintain get the tile thumbnail from a project
// so we create this backward-compatible function to use in all places
// doc: https://archipro.atlassian.net/wiki/spaces/AD/pages/1788313607
export const getProjectTileThumbnail = (
    project: projectWithThumbnail,
    isMobile?: boolean
): string => {
    if (isBasicThumbnail(project)) {
        const thumbnail = isMobile
            ? project.Thumbnail?.mobile
            : project.Thumbnail?.desktop;
        if (thumbnail) {
            return thumbnail;
        }
    }

    // check if project is a SearchResultItem
    if (isSearchResultItem(project)) {
        const thumbs = project.LibraryThumbs;
        const directoryTiles =
            project.DirectoryTiles?.filter((imageTile) => imageTile.Thumb) ??
            [];

        const preferredThumb = directoryTiles?.[0]?.Thumb;

        return (
            preferredThumb ?? thumbs?.Thumb_category ?? thumbs?.Thumb_lg ?? ''
        );
    }

    return '';
};
